module.exports = __webpack_public_path__ + "img/main_dsw.454596b4.jpg";